/// <amd-module name="VSSUI/Components/Card/CustomCard" />
import * as React from "react";
import { ICardProps } from "./Card.Props";

import { Spacing, Surface, SurfaceBackground, SurfaceContext } from "VSSUI/Surface";
import { css } from "VSSUI/Util";

export const CustomCard: React.SFC<ICardProps> = props => {
    return (
        <SurfaceContext.Consumer>
            {surfaceContext => (
                <Surface {...surfaceContext} spacing={Spacing.default}>
                    <div
                        className={css(
                            props.className,
                            "bolt-card flex-column depth-8",
                            surfaceContext.background === SurfaceBackground.neutral && "bolt-card-white"
                        )}
                    >
                        {props.children}
                    </div>
                </Surface>
            )}
        </SurfaceContext.Consumer>
    );
};
